import { Container, Graphics, Text, TextStyle } from 'pixi.js';
import { Menu } from './Menu.js';

export class PauseMenu extends Menu {
    constructor(app) {
        super(app);
        this.title = 'Paused';
        this.onResume = null;
        this.onExit = null;
        this.create();
    }

    create() {
        // Create background
        const bg = new Graphics();
        bg.beginFill(0x000000, 0.8);
        bg.drawRoundedRect(0, 0, 400, 300, 20);
        bg.endFill();
        this.container.addChild(bg);

        // Create title
        const titleStyle = new TextStyle({
            fontFamily: '"Press Start 2P"',
            fontSize: 24,
            fill: 0xFFFFFF,
            align: 'center'
        });

        const title = new Text(this.title, titleStyle);
        title.x = 200;
        title.y = 50;
        title.anchor.set(0.5);
        this.container.addChild(title);

        // Create buttons container
        const buttonsContainer = new Container();
        buttonsContainer.y = 100;
        this.container.addChild(buttonsContainer);

        this.createButtons(buttonsContainer);

        // Add to stage
        this.app.stage.addChild(this.container);

        // Center on screen
        this.updatePosition();
    }

    createButtons(container) {
        // Create resume button
        const resumeButton = this.createButton('Resume Game', 0, () => this.onResume?.());
        container.addChild(resumeButton);

        // Create exit button
        const exitButton = this.createButton('Exit Game', 60, () => this.onExit?.());
        container.addChild(exitButton);
    }

    createButton(text, yOffset, onClick) {
        const button = new Container();
        button.y = yOffset;
        button.interactive = true;
        button.buttonMode = true;

        // Create button background
        const bg = new Graphics();
        bg.beginFill(0x333333);
        bg.drawRoundedRect(0, 0, 200, 40, 10);
        bg.endFill();
        button.addChild(bg);

        // Create button text
        const textStyle = new TextStyle({
            fontFamily: '"Press Start 2P"',
            fontSize: 14,
            fill: 0xFFFFFF,
            align: 'center'
        });

        const buttonText = new Text(text, textStyle);
        buttonText.x = 100;
        buttonText.y = 20;
        buttonText.anchor.set(0.5);
        button.addChild(buttonText);

        // Add hover effects
        button.on('pointerover', () => {
            bg.clear();
            bg.beginFill(0x666666);
            bg.drawRoundedRect(0, 0, 200, 40, 10);
            bg.endFill();
        });

        button.on('pointerout', () => {
            bg.clear();
            bg.beginFill(0x333333);
            bg.drawRoundedRect(0, 0, 200, 40, 10);
            bg.endFill();
        });

        button.on('pointerdown', onClick);

        return button;
    }

    updatePosition() {
        this.container.x = (this.app.screen.width - 400) / 2;
        this.container.y = (this.app.screen.height - 300) / 2;
    }

    show() {
        this.container.visible = true;
    }

    hide() {
        this.container.visible = false;
    }

    destroy() {
        this.container.destroy();
    }
} 